import { render, staticRenderFns } from "./Greeting.vue?vue&type=template&id=d236d7d6"
import script from "./Greeting.vue?vue&type=script&lang=js"
export * from "./Greeting.vue?vue&type=script&lang=js"
import style0 from "./Greeting.vue?vue&type=style&index=0&id=d236d7d6&prod&lang=css"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports